const removePrefix = (value, prefix) =>
  value.startsWith(prefix) ? value.slice(prefix.length) : value

export { removePrefix }
export default removePrefix
